module.exports = __webpack_public_path__ + "static/img/404.7b2ae75d.png";